import React from 'react';
import { isAndroid } from 'react-device-detect';
import { CDN_TYPE_BASE, getCDNUrl } from 'utils';

import { printMissingConfigError, SiteConfigManager, StorageManager } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

export const BannerApplicationLinkAndroid = () => {
  const [isBannerWasShowed, setIsBannerWasShowed] = React.useState(
    JSON.parse(StorageManager.getItem('appLinkBannerIsShowed')),
  );
  const [showBanner, setShowBanner] = React.useState(false);
  const appShowInHeader = SiteConfigManager.getConfig('config.config.applicationLink.showInHeader');
  const appShowDelay = SiteConfigManager.getConfig('config.config.applicationLink.delay') || 0;
  const appName = SiteConfigManager.getConfig('config.config.applicationLink.name');
  const appDescription = SiteConfigManager.getConfig('config.config.applicationLink.description');
  const appLink = SiteConfigManager.getConfig('config.config.applicationLink.url');
  const appIcon = SiteConfigManager.getConfig('config.config.applicationLink.icon');
  const appRating = SiteConfigManager.getConfig('config.config.applicationLink.rating');

  const showBannerFromConfig = appShowInHeader && appLink.length && appName.length;

  const appIconUrl = new URL(appIcon, getCDNUrl(CDN_TYPE_BASE));
  const delay = appShowDelay * 1000;

  const onCloseBannerHandler = React.useCallback(() => {
    StorageManager.setItem('appLinkBannerIsShowed', 'true');
    setIsBannerWasShowed(true);
    setShowBanner(false);
  }, []);

  React.useEffect(() => {
    if (!isBannerWasShowed && showBannerFromConfig) {
      if (delay) {
        const timerId = setTimeout(() => {
          setShowBanner(true);
        }, delay);

        return () => clearTimeout(timerId);
      } else {
        setShowBanner(true);
      }
    }
  }, [delay, isBannerWasShowed, showBannerFromConfig]);

  if (appShowInHeader && (!appName || !appDescription || !appLink || !appIcon || !appRating)) {
    printMissingConfigError(
      'config.config.applicationLink[delay|name|description|url|icon|rating]',
    );
  }

  if (!isAndroid || !showBannerFromConfig) return null;

  if ((!isBannerWasShowed || isBannerWasShowed === true) && !showBanner) return null;

  return (
    <div className="banner-application-link">
      <Icon
        className="banner-application-link__close"
        name="close"
        onClick={onCloseBannerHandler}
      />
      <a className="banner-application-link__wrapper" href={appLink}>
        {appIcon && (
          <div className="banner-application-link__icon">
            <img alt="icon" src={appIconUrl} />
          </div>
        )}
        <div className="banner-application-link__content">
          <Label className="banner-application-link__title" message={appName} />
          {appRating !== 0 ? (
            <div className="custom-star-rating">
              <div className="star-item-wrapper">
                {Array.from({ length: 5 }).map((number, index) => (
                  <div className="star-item" key={index}>
                    <Icon height={10} name="star-border" width={10} />
                    <div
                      className="star-item-progress"
                      style={{
                        width:
                          index + 1 <= Math.floor(appRating)
                            ? '100%'
                            : `${Math.max(0, appRating - index) * 100}%`,
                      }}
                    >
                      <Icon height={10} name="star-rate" width={10} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="custom-star-rating">
              <div className="star-item-wrapper">
                {Array.from({ length: 5 }).map((number, index) => (
                  <div className="star-item" key={index}>
                    <Icon height={10} name="star-border" width={10} />
                  </div>
                ))}
              </div>
            </div>
          )}
          {appDescription && (
            <Label className="banner-application-link__get-on" message={appDescription} />
          )}
        </div>
        <div className="banner-application-link__button">
          <Label message="View" />
        </div>
      </a>
    </div>
  );
};
